import { Component, OnInit } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import * as SecureLS from "secure-ls";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ExcelServicesService } from "../../../services/excel.service";
import { StorageService } from "../../../services/storage.service";
import { CommonService } from "src/app/services/common.service";
interface dropdata {
  value: string;
  viewValue: string;
}
interface user_access_type {
  value: string;
  viewValue: string;
}
@Component({
  selector: "app-video-reports-newlist",
  templateUrl: "./video-reports-newlist.component.html",
  styleUrls: ["./video-reports-newlist.component.css"],
})
export class VideoReportsNewlistComponent implements OnInit {
  dropdatas: dropdata[] = [
    { value: "1", viewValue: "Professor" },
    { value: "2", viewValue: "Learner" },
  ];
  user_access_type: user_access_type[] = [
    { value: "1", viewValue: "Accessed Users" },
    { value: "2", viewValue: "Non accessed Users" },
  ];
  private ls = new SecureLS({ encodingType: "aes" });
  total_count = 0;
  video: any;
  vid: any;
  getVideo: any;
  videoList: any[] = [];
  uivideoList: any;
  excelVideoList: any[];
  department_id: any;
  minDate = new Date();
  maxDate = new Date();
  filter_from: any;
  filter_end: any;
  form: FormGroup;
  batch_id: string;
  filter: any;
  department: any;
  classroom: any;
  class: any;
  batch: any;
  subject: any;
  total: number;
  searchForm: FormGroup;
  reportrole: number;
  diff: any;
  batchData1: any;
  dept: any;
  user_type: string;
  user_type1: string;
  recrange: any;
  limit = 1000;
  dropbox: Array<Object> = [];
  check: number;
  offset = 0;
  filtervalues: boolean;
  chiparray = [];
  countvalue: number = 0;
  pageshow: boolean = true;
  page_count: any[];
  htmlpageshow: boolean;
  pagedItems: any[];
  page: number = 1;
  page_size: number = 10;
  p: number;
  hod: any;
  sessionData: any;
  findedVal: any;
  professor_id: any;
  ishod: number;
  role: number;
  professorname: Object;
  professorData: any;
  pageno: any;
  user_access_report: string;
  non_accessed_students: number;
  access_control: number = 0;
  user_access_report1: string;
  isLoginType: boolean;
  subjectData: any;
  constructor(
    private storageService: StorageService,
    private datepipe: DatePipe,
    private route: ActivatedRoute,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService
  ) {
    this.role = this.storageService.getRole();
  }
  usertype(event: any) {
    if (event.source.value == "1") {
      this.reportrole = 4;
      this.user_type1 = "Professor";
      this.batch_id = null;
    } else {
      this.reportrole = 5;
      this.user_type1 = "Learner";
      this.batch_id = null;
    }
  }
  useraccesstype(event: any) {
    if (event.source.value == "1") {
      this.user_access_report = "Accessed Users";
      this.non_accessed_students = 0;
    } else {
      this.user_access_report = "Non Accessed Users";
      this.non_accessed_students = 1;
    }
  }
  async ngOnInit() {
    this.hod = this.storageService.getHod();
    this.maxDate = new Date();
    // Remove or adjust minDate to allow dates before July
    this.minDate = null; // No minimum date restriction
    // Alternatively, set a very early date:
    // this.minDate = new Date(2000, 0, 1); // January 1, 2000
    this.maxDate.setDate(this.maxDate.getDate() - 1);
    this.searchForm = this.fb.group({
      id: [null],
      date: [null, [Validators.required]],
      user: [null, [Validators.required]],
      user_access_type: [null, [Validators.required]],
      batchId: [null],
      depname: [null],
      batchname: [null],
      proname: [null],
      proffname: [null],
      session: [null],
    });
    if (this.route.queryParams["value"].loginType == "impersonate") {
      this.isLoginType = true;
    }
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);

    }
    if (this.storageService.getRole() == 4) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      // this.searchForm.controls["depname"].setValue(this.department_id);
      this.department_id = this.storageService.getDepartment();

      this.searchForm.controls["depname"].setValue(this.department_id);
      this.searchForm.controls["depname"].disable();
      this.searchForm.controls["depname"].disable();
      if (this.hod !== 1) {
        this.searchForm.controls["proname"].disable();
      }
    }
    this.page = 1;
    await this.getDepartment();
    this.getBatch();
    this.getProfessor();
  }
  async getPage(page: number) {
    this.page = page;
    this.getVideoDetails();
    const res = await this.serverCall(this.videoList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }
  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  getvalue(event: any, rec: any, offset: number) {
    this.spinner.show();
    this.recrange = rec;
    this.offset = offset;
    this.pageno = event;
    this.exportAsXLSX();
  }
  async dropboxdown() {
    this.dropbox = [];
    var count = 5000,
      tempcount = 5000,
      c1,
      c2;
    var offset = 0;
    this.check = Math.ceil(this.countvalue / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2, offset: offset });
      offset += 5000;
    }
  }
  get forms() {
    return this.searchForm.controls;
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.storageService.getCreatedBy(),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );
    this.dept = this.department["content"];
    this.spinner.hide();
  }
  async onSessionChangeEvent(isInitLoad?) {
    this.forms["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      await this.getSubjectDropdown();
      // Set minDate to session start_date or remove restriction
      this.minDate = new Date(this.findedVal.start_date); // Use session start date
      // Alternatively, set to null for no restriction:
      // this.minDate = null;
      this.maxDate = new Date(); // Allow up to current date
      if (isInitLoad) {
        let splitedChipArray = null;
        if (this.chiparray.length) {
          this.chiparray.forEach((elem) => {
            if (elem.split(" : ")[0] === "Date") {
              splitedChipArray = elem.split(" : ")[1].split(" - ");
            }
          });
        }
        if (splitedChipArray?.length) {
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.forms["date"].setValue(convertedDates);
          this.getFilterDate(convertedDates);
        } else {
          this.forms["date"].setValue([new Date(), new Date()]);
          this.getFilterDate([new Date(), new Date()]);
        }
      }
    } else {
      this.forms["date"].setValue(null);
      this.getFilterDate(null);
      this.minDate = null; // No restriction if no session selected
    }
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    if (this.findedVal?.id) {
      filter.session_id = this.findedVal.id;
    }

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      subname: null,
    });
  }

  // getFilterDate(filter_date) {
  //   if (filter_date) {
  //     this.filter = filter_date;
  //     this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
  //     this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
  //     var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  //     var diffDays =
  //       Math.floor(
  //         new Date(this.filter_from).getTime() -
  //         new Date(this.filter_end).getTime()
  //       ) / oneDay;
  //     // if (-diffDays > 180) {
  //     //   Swal.fire({
  //     //     text: "Please select dates within 180 days",
  //     //     icon: "warning",
  //     //     confirmButtonText: "OK",
  //     //     confirmButtonColor: "#808080",
  //     //   });
  //     //   this.searchForm.controls["date"].setValue(""); 
  //     // }
  //   }
  // }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      // No need for 180-day validation, so keep it removed or ensure it’s not re-enabled
    }
  }
  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.storageService.getCreatedBy(),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );
    this.batchData1 = this.batch["content"];
    this.spinner.hide();
  }

  async onDepartmentChange(departmentId: any) {
    await this.getSubjectDropdown();
    this.department_id = departmentId || null;

    // Clear professor selection
    this.professor_id = null;
    this.searchForm.get('proffname')?.setValue(null);
    this.searchForm.get('proname')?.setValue(null);

    await this.getProfessor(false);
  }

  async getProfessor(isInit: boolean = true) {
    this.spinner.show();
    const currentDeptId = this.department_id || this.searchForm?.get("depname")?.value;
    let filter: any = {
      user_id: this.storageService.getCreatedBy(),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      department_id: currentDeptId,
    };

    if (this.role !== 4 && !currentDeptId) {
      this.professorname = { content: [] };
      this.professorData = [];
    } else {
      this.professorname = await this.globalService.get(
        "user/profeser/dropdown",
        filter,
        true
      );
      this.professorData = this.professorname["content"] || [];
    }

    if (this.isLoginType && this.storageService.getRole() == 4 && this.hod !== 1) {

      const professor = (this.professorData || []).find(
        p => p.id == this.professor_id
      );

      if (professor) {
        this.department_id = professor.department_id;
        this.searchForm.controls["depname"].setValue(professor.department_id);
        this.searchForm.controls["depname"].disable();
      }
    }
    if (isInit) {
      // GET SESSION
      let session = await this.globalService.get(
        "session/dropdown",
        filter,
        true
      );
      this.sessionData = session["content"];
      this.usertype({ source: { value: 1 } });
      this.user_type = this.dropdatas[0]?.value;
      this.useraccesstype({ source: { value: 1 } });
      this.user_access_report1 = this.user_access_type[0]?.value;
      this.forms["session"].setValue(
        this.storageService.getCurrentSession(this.sessionData)?.session
      );
      this.findedVal = this.sessionData.find(
        (list) => list.session === this.searchForm.controls["session"]?.value
      );
      this.onSessionChangeEvent(true);
      this.Filter();
    } else {
      this.spinner.hide();
    }
  }
  expandRow(eList) {
    this.videoList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }
  collapseRow(eList) {
    this.videoList.forEach((list) => {
      list["isExpand"] = false;
    });
  }
  async getVideoDetails() {
    if (this.page === 1) {
      this.videoList = [];
    }
    this.spinner.show();
    let filter: any = {
      user_id: this.storageService.getCreatedBy(),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id,
      report_role: this.reportrole,
      non_accessed_students: this.non_accessed_students,
      page: this.page,
      page_size: this.page_size,
      session_id: this.findedVal?.id,
    };

    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));
    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.start_date + " - " + filter.end_date);
    }
    await this.globalService
      .get("classVideoDetail/video/access/detail/report", filter)
      .then((data) => {
        this.getVideo = data;
        this.videoList = this.getVideo["content"]["rows"];
        this.videoList = this.videoList.map((list) => {
          list["isExpand"] = false;
          return list;
        });
        this.spinner.hide();
        this.countvalue = 0;
        if (this.non_accessed_students) {
          this.access_control = 1;
        }
        else {
          this.access_control = 0;
        }
        if (this.getVideo["status"] === 200) {
          // this.videoList = this.getVideo["content"]["rows"];
          this.countvalue = this.getVideo["content"]["count"];
          this.total_count = this.videoList.length;
          this.dropboxdown();
          if (this.pageshow === true) {
            this.page_count = [];
            let page_count = Math.ceil(this.countvalue / this.page_size);
            if (page_count > 1) {
              this.htmlpageshow = true;
            } else {
              this.htmlpageshow = false;
            }
            this.spinner.hide();
          }
        }
      });
    this.spinner.hide();
  }
  async exportAsXLSX(): Promise<void> {
    let professorId = this.professor_id;
    if (window.location.href.indexOf("impersonate") !== -1) {
      professorId = this.storageService.getProfessor();
    }
    let filter: any = {
      user_id: this.storageService.getCreatedBy(),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: professorId,
      non_accessed_students: this.non_accessed_students,
      report_role: this.reportrole,
      page: this.total_count > 5000 ? this.pageno : 1,
      page_size: 5000,
      session_id: this.findedVal?.id,
    };
    this.spinner.show();
    this.getVideo = await this.globalService.get(
      "classVideoDetail/video/access/detail/report",
      filter
    );
    this.excelVideoList = this.getVideo["content"]["rows"];
    if (this.excelVideoList && this.getVideo["status"] == 200 && !this.non_accessed_students) {
      this.uivideoList = this.excelVideoList.map((item: any) => {
        const baseData: any = {};
        baseData['Professor_Trainer'] = item.video_details.professor_details.first_name + " " + item.video_details.professor_details.last_name;
        if (this.reportrole === 5) {
          baseData['Subject'] = item.video_details.subject_details ? item.video_details.subject_details.name : "";
        }
        baseData['Class_room'] = item.video_details ? (item.video_details.classroom_details ? item.video_details.classroom_details.name : "") : "";
        if (item.video_details) {
          if (item.video_details.start_date == item.video_details.end_date) {
            baseData['Date Time'] = item.video_details.start_date + " " + (item.video_details.start_time + " to " + item.video_details.start_time)
          } else {
            baseData['Date Time'] = item.video_details.start_date + " " + item.video_details.start_time + " to " + item.video_details.end_date + " " + item.video_details.end_time
          }
        }
        baseData['User Name'] = item.student_details.first_name + " " + item.student_details.last_name;
        baseData['User Email'] = item.student_details.email_address;
        baseData['Department'] = item.student_details.department ? item.student_details.department.name : "";
        if (this.reportrole === 5) {
          baseData['Section'] = item.student_details.section ? item.student_details.section : "";
          baseData['Batch'] = item.student_details.batch ? item.student_details.batch.batch : "";
        }
        baseData['Duration'] = item.duration ? item.duration : 0;
        baseData['Last Accessed At'] = this.datepipe.transform(item.access_end_time, "yyyy-MM-dd");
        return baseData;
      });
    }
    if (this.excelVideoList && this.getVideo["status"] == 200 && this.non_accessed_students) {
      this.uivideoList = this.excelVideoList.map((item: any) => {
        const baseData = {
          Name: item.first_name + " " + item.last_name,
          Username: item.username,
          Email_Address: item.email_address,
          Mobile_Number: item.mobile_number,
          Department: item.dep_name ? item.dep_name : "",
        };
        if (this.reportrole === 5) {
          baseData['Section'] = item.section ? item.section : "";
          baseData['Batch'] = item.batch_name ? item.batch_name : "";
        }
        return baseData;
      });
    }
    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      "Video_Access_Report" + "" + [this.recrange]
    );
    this.recrange = "";
    this.offset = 0;
    this.spinner.hide();
  }
  openScrollableContent(longContent) {
    this.findedVal = null;
    const today = new Date();
    this.searchForm.controls["date"].setValue([today, today]);
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    // this.searchForm.reset();
    if (!this.forms["session"].value) {
      this.forms["session"].setValue(
        this.storageService.getCurrentSession(this.sessionData)?.session
      );
    }
    this.onSessionChangeEvent(true);
    if (this.storageService.getRole() === 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() === 4 && this.hod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable();
      const professor = this.professorData?.find(
        p => p.id == this.professor_id
      );

      if (professor) {
        this.department_id = professor.department_id;
        this.searchForm.controls["depname"].setValue(professor.department_id);
        this.searchForm.controls["depname"].disable();
      }
    }
  }
  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getVideoDetails();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getVideoDetails();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getVideoDetails();
  }

  Filter() {
    this.filtervalues = true;
    this.chiparray = [];

    const deptId = this.searchForm.get('depname')?.value;
    const profId =
      this.searchForm.get('proname')?.value ||
      this.searchForm.get('proffname')?.value;

    this.department_id = deptId;
    this.professor_id = profId;
    this.batch_id = this.searchForm.get('batchname')?.value;

    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }

    if (this.user_type != undefined && this.user_type != "") {
      this.chiparray.push("User type: " + this.user_type1);
    }

    if (profId) {
      const professor = (this.professorData || []).find(
        (x) => x.id == profId
      );

      if (professor) {
        this.chiparray.push(
          "Proff: " +
          professor.first_name +
          " " +
          professor.last_name
        );
      }
    }

    if (deptId) {
      const dept = (this.dept || []).find(
        (x) => x.id == deptId
      );

      if (dept) {
        this.chiparray.push("Dept: " + dept.name);
      }
    }

    if (this.batch_id) {
      const batch = (this.batchData1 || []).find(
        (x) => x.id == this.batch_id
      );

      if (batch) {
        this.chiparray.push("Batch: " + batch.batch);
      }
    }

    this.pageshow = true;
    this.page = 1;
    this.getVideoDetails();
  }
  res() {
    this.filtervalues = false;
    this.chiparray = [];

    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );

    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    );

    this.chiparray.push("User type: " + this.user_type1);

    // HOD
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      const dept = (this.dept || []).find(
        (x) => x.id == this.department_id
      );

      if (dept) {
        this.chiparray.push("Dept: " + dept.name);
      }

      this.professor_id = null;
    }

    // Professor
    if (this.storageService.getRole() == 4 && this.hod != 1) {
      const proff = (this.professorData || []).find(
        (x) => x.id == this.professor_id
      );

      if (proff) {
        this.chiparray.push(
          "Proff: " +
          proff.first_name +
          " " +
          proff.last_name
        );
      }

      const dept = (this.dept || []).find(
        (x) => x.id == this.department_id
      );

      if (dept) {
        this.chiparray.push("Dept: " + dept.name);
      }
    }

    if (this.storageService.getRole() != 4) {
      this.department_id = null;
      this.professor_id = null;
      this.searchForm.get('depname')?.setValue(null);
      this.searchForm.get('proffname')?.setValue(null);
      this.searchForm.get('proname')?.setValue(null);
      this.professorData = [];
    }

    this.filter_from = null;
    this.filter_end = null;
    this.batch_id = null;
    this.videoList = [];
    this.htmlpageshow = false;

    this.findedVal = this.sessionData?.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    ) || null;

    this.getVideoDetails();
  }


  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getVideoDetails();
  }
}
